var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "print-pdf" },
    [
      this.postsSortByImpression &&
      _vm.graphData &&
      _vm.pageStats !== null &&
      _vm.pageStats &&
      _vm.pageStats.page &&
      _vm.pageStats.page.previous_period &&
      _vm.currentPage &&
      _vm.getPreviousPeriod &&
      _vm.graphLabels &&
      _vm.dateStart &&
      _vm.dateEnd
        ? [
            _c(
              "div",
              { staticClass: "slide slide1" },
              [
                _c("SlideHome", {
                  attrs: {
                    PageName: _vm.currentPage.name,
                    Network: _vm.currentPage.network,
                    DateStart: new Date(_vm.dateStart),
                    DateEnd: new Date(_vm.dateEnd),
                    PictureUrl: _vm.currentPage.avatar,
                  },
                }),
              ],
              1
            ),
            ["facebook", "linkedin", "instagram", "tiktok"].includes(
              _vm.currentPage.network
            )
              ? _c(
                  "div",
                  { staticClass: "slide slide3" },
                  [
                    _c("ComponentHeader", {
                      attrs: {
                        SectionName: this.$t(
                          "dash.reporting.pdf.visibility.sectionName"
                        ),
                        SubSectionName: this.$t(
                          "dash.reporting.pdf.visibility.main.subSectionName"
                        ),
                        Description:
                          "Analyse de votre visibilité au cours de la période sélectionnée",
                        Network: _vm.currentPage.network,
                        PictureUrl: _vm.currentPage.avatar,
                      },
                    }),
                    _vm.graphData && _vm.pageStats && _vm.pageStats.page
                      ? _c("SlideResumeSection", {
                          attrs: { Items: _vm.getDataSlide[3].dataResume },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            ["facebook", "instagram", "tiktok"].includes(
              _vm.currentPage.network
            ) &&
            _vm.getDataSlide[4] &&
            _vm.getDataSlide[4].dataGraph[0].data.length
              ? _c(
                  "div",
                  { staticClass: "slide slide4" },
                  [
                    _c("ComponentHeader", {
                      attrs: {
                        SectionName: this.$t(
                          "dash.reporting.pdf.visibility.sectionName"
                        ),
                        SubSectionName: this.$t(
                          "dash.reporting.pdf.visibility.followers.subSectionName"
                        ),
                        Description: this.$t(
                          "dash.reporting.pdf.visibility.followers.description"
                        ),
                        Network: _vm.currentPage.network,
                        PictureUrl: _vm.currentPage.avatar,
                      },
                    }),
                    _c("Graph", {
                      attrs: {
                        id: "graph_daily_follows",
                        data: _vm.getDataSlide[4].dataGraph,
                        labels: _vm.graphLabels,
                        width: "1324px",
                        height: "644.4px",
                      },
                    }),
                    _c(
                      "div",
                      { staticClass: "text-data" },
                      [
                        _c("ComponentTab", {
                          attrs: {
                            values: _vm.getDataSlide[4].dataTab.values,
                            totals: _vm.getDataSlide[4].dataTab.totals,
                          },
                        }),
                        _c("ComponentTextResume", {
                          attrs: {
                            title: _vm.getDataSlide[4].dataTextResume.title,
                            value: _vm.getDataSlide[4].dataTextResume.value,
                            label: _vm.getDataSlide[4].dataTextResume.label,
                            pourcentage:
                              _vm.getDataSlide[4].dataTextResume.pourcentage,
                            DateStart: new Date(
                              _vm.getPreviousPeriod.start
                                .split("/")
                                .reverse()
                                .join("-")
                            ),
                            DateEnd: new Date(
                              _vm.getPreviousPeriod.end
                                .split("/")
                                .reverse()
                                .join("-")
                            ),
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            ["facebook", "linkedin", "instagram", "tiktok"].includes(
              _vm.currentPage.network
            )
              ? _c(
                  "div",
                  { staticClass: "slide slide5" },
                  [
                    _c("ComponentHeader", {
                      attrs: {
                        SectionName: this.$t(
                          "dash.reporting.pdf.visibility.sectionName"
                        ),
                        SubSectionName: this.$t(
                          "dash.reporting.pdf.visibility.interaction.subSectionName"
                        ),
                        Description: this.$t(
                          "dash.reporting.pdf.visibility.interaction.description"
                        ),
                        Network: _vm.currentPage.network,
                        PictureUrl: _vm.currentPage.avatar,
                      },
                    }),
                    _c("Graph", {
                      attrs: {
                        id: "graph_interaction",
                        data: _vm.getDataSlide[5].dataGraph,
                        labels: _vm.graphLabels,
                        height: "658px",
                        width: "1324px",
                      },
                    }),
                    _c(
                      "div",
                      { staticClass: "text-data" },
                      [
                        _c("ComponentTab", {
                          attrs: {
                            values: _vm.getDataSlide[5].dataTab.values,
                            totals: _vm.getDataSlide[5].dataTab.totals,
                          },
                        }),
                        _c("ComponentTextResume", {
                          attrs: {
                            title: _vm.getDataSlide[5].dataTextResume.title,
                            value: _vm.getDataSlide[5].dataTextResume.value,
                            label: _vm.getDataSlide[5].dataTextResume.label,
                            pourcentage:
                              _vm.getDataSlide[5].dataTextResume.pourcentage,
                            DateStart: new Date(
                              _vm.getPreviousPeriod.start
                                .split("/")
                                .reverse()
                                .join("-")
                            ),
                            DateEnd: new Date(
                              _vm.getPreviousPeriod.end
                                .split("/")
                                .reverse()
                                .join("-")
                            ),
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            ["facebook", "tiktok"].includes(_vm.currentPage.network) &&
            _vm.pageStats.page.impression_posts_graph
              ? _c(
                  "div",
                  { staticClass: "slide slide6" },
                  [
                    _c("ComponentHeader", {
                      attrs: {
                        SectionName: this.$t(
                          "dash.reporting.pdf.visibility.sectionName"
                        ),
                        SubSectionName: this.$t(
                          "dash.reporting.pdf.visibility.print.subSectionName"
                        ),
                        Description: this.$t(
                          "dash.reporting.pdf.visibility.print.description"
                        ),
                        Network: _vm.currentPage.network,
                        PictureUrl: _vm.currentPage.avatar,
                      },
                    }),
                    _c("Graph", {
                      attrs: {
                        id: "graph_impression",
                        data: _vm.pageStats
                          ? [
                              {
                                data: _vm.pageStats.page.impression_posts_graph.map(
                                  (d, index) => d.total
                                ),
                                label: _vm.$t("dash.reporting.impression"),
                                type: "line",
                              },
                            ]
                          : [],
                        labels: _vm.graphLabels,
                        height: "762px",
                        width: "1324px",
                      },
                    }),
                    _c(
                      "div",
                      { staticClass: "text-data" },
                      [
                        _vm.graphData && _vm.pageStats && _vm.pageStats.page
                          ? _c("ComponentTextResume", {
                              attrs: {
                                title: "Le total est de",
                                value:
                                  _vm.pageStats.page.totalImpressions.toString(),
                                label: "impressions",
                                pourcentage:
                                  _vm.pageStats.page.previous_period &&
                                  _vm.pageStats.page.previous_period
                                    .totalImpressions
                                    ? Math.round(
                                        ((_vm.pageStats.page.totalImpressions -
                                          _vm.pageStats.page.previous_period
                                            .totalImpressions) /
                                          _vm.pageStats.page.previous_period
                                            .totalImpressions) *
                                          100,
                                        2
                                      )
                                    : 0,
                                DateStart: new Date(
                                  _vm.getPreviousPeriod.start
                                    .split("/")
                                    .reverse()
                                    .join("-")
                                ),
                                DateEnd: new Date(
                                  _vm.getPreviousPeriod.end
                                    .split("/")
                                    .reverse()
                                    .join("-")
                                ),
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            ["instagram"].includes(_vm.currentPage.network) &&
            _vm.getDataSlide[7]
              ? _c(
                  "div",
                  { staticClass: "slide slide7" },
                  [
                    _c("ComponentHeader", {
                      attrs: {
                        SectionName: this.$t(
                          "dash.reporting.pdf.visibility.sectionName"
                        ),
                        SubSectionName: this.$t(
                          "dash.reporting.pdf.visibility.demographicData.subSectionName"
                        ),
                        Description: this.$t(
                          "dash.reporting.pdf.visibility.demographicDataAll.description"
                        ),
                        Network: _vm.currentPage.network,
                        PictureUrl: _vm.currentPage.avatar,
                      },
                    }),
                    _c(
                      "div",
                      { staticClass: "persona" },
                      [
                        _vm.graphData && _vm.pageStats && _vm.pageStats.page
                          ? _c("ComponentTextPersona", {
                              attrs: { stats: _vm.pageStats.page },
                            })
                          : _vm._e(),
                        _c("Graph2", {
                          attrs: {
                            id: "stat-gender",
                            data: _vm.getDataSlide[7].dataGraphGenderValues,
                            labels: _vm.getDataSlide[7].dataGraphGenderLabels,
                            width: "600px",
                          },
                        }),
                        _c("Graph2", {
                          attrs: {
                            id: "stat-age",
                            data: _vm.getDataSlide[7].dataGraphAgeValues,
                            labels: _vm.getDataSlide[7].dataGraphAgeLabels,
                            width: "600px",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            ["facebook", "instagram", "tiktok"].includes(
              _vm.currentPage.network
            ) &&
            _vm.getDataSlide[8] &&
            _vm.getDataSlide[8].dataGraph
              ? _c(
                  "div",
                  { staticClass: "slide slide8" },
                  [
                    _c("ComponentHeader", {
                      attrs: {
                        SectionName: this.$t(
                          "dash.reporting.pdf.visibility.sectionName"
                        ),
                        SubSectionName: this.$t(
                          "dash.reporting.pdf.visibility.demographicData.subSectionName"
                        ),
                        Description: this.$t(
                          "dash.reporting.pdf.visibility.demographicDataCountry.description"
                        ),
                        Network: _vm.currentPage.network,
                        PictureUrl: _vm.currentPage.avatar,
                      },
                    }),
                    _c(
                      "div",
                      { staticClass: "map" },
                      [
                        _c("MapChart", {
                          attrs: {
                            countryData: _vm.getDataSlide[8].dataGraph,
                            highColor: "rgba(106, 31, 76, 1)",
                            lowColor: "rgba(106, 31, 76, 0.1)",
                            countryStrokeColor: "#ffffff",
                            defaultCountryFillColor: "#dadada",
                            LangUser: _vm.$i18n.locale,
                            currencyAdd: false,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "legendMap" },
                      _vm._l(
                        Object.entries(_vm.getDataSlide[8].dataGraph)
                          .slice()
                          .sort((a, b) => parseFloat(b[1]) - parseFloat(a[1]))
                          .slice(0, 3),
                        function (countryData) {
                          return _c("p", { key: countryData[0] }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.country[countryData[0]]) +
                                "\n                    "
                            ),
                            _c("span", [
                              _vm._v("(" + _vm._s(countryData[1]) + "%)"),
                            ]),
                          ])
                        }
                      ),
                      0
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.currentPage.network === "tiktok" &&
            _vm.getDataSlide[9] &&
            _vm.getDataSlide[9].dataGraphGenderAge &&
            _vm.getDataSlide[9].dataGraphGenderAge.length
              ? _c(
                  "div",
                  { staticClass: "slide slide9" },
                  [
                    _c("ComponentHeader", {
                      attrs: {
                        SectionName: this.$t(
                          "dash.reporting.pdf.visibility.sectionName"
                        ),
                        SubSectionName: this.$t(
                          "dash.reporting.pdf.visibility.demographicData.subSectionName"
                        ),
                        Description: this.$t(
                          "dash.reporting.pdf.visibility.demographicDataAll.description"
                        ),
                        Network: _vm.currentPage.network,
                        PictureUrl: _vm.currentPage.avatar,
                      },
                    }),
                    _c("div", { staticClass: "demographic-content" }, [
                      _c(
                        "div",
                        { staticClass: "demographic-graph" },
                        [
                          _c("Graph", {
                            attrs: {
                              id: "graph_demographic_tiktok",
                              data: _vm.getDataSlide[9].dataGraphGenderAge,
                              labels: _vm.getDataSlide[9].labels,
                              height: "600px",
                              width: "800px",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.getDataSlide[9].fansByGender &&
                      _vm.getDataSlide[9].fansByGender.length
                        ? _c(
                            "div",
                            { staticClass: "demographic-gender" },
                            [
                              _c("componentGraph", {
                                attrs: {
                                  data: [
                                    {
                                      name: "fans_by_gender",
                                      type: "doughnut",
                                      data: _vm.getDataSlide[9].fansByGender.map(
                                        (item) =>
                                          typeof item === "object"
                                            ? item.value || item.total || 0
                                            : item
                                      ),
                                      color: ["#4c34e5", "#e53481", "#df34e5"],
                                    },
                                  ],
                                  state: ["0"],
                                  labels: [
                                    _vm.$t("page_follows_by_gender_male"),
                                    _vm.$t("page_follows_by_gender_female"),
                                    _vm.$t("page_follows_by_gender_undefined"),
                                  ],
                                  section: "pdf_gender_tiktok",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            ["facebook", "instagram"].includes(_vm.currentPage.network)
              ? _c(
                  "div",
                  { staticClass: "slide slide9" },
                  [
                    _c("ComponentHeader", {
                      attrs: {
                        SectionName: this.$t(
                          "dash.reporting.pdf.visibility.sectionName"
                        ),
                        SubSectionName: this.$t(
                          "dash.reporting.pdf.visibility.demographicData.subSectionName"
                        ),
                        Description: this.$t(
                          "dash.reporting.pdf.visibility.demographicDataCoutryCity.description"
                        ),
                        Network: _vm.currentPage.network,
                        PictureUrl: _vm.currentPage.avatar,
                      },
                    }),
                    _vm.getDataSlide[9]
                      ? _c("div", { staticClass: "stat-country-city" }, [
                          _c(
                            "div",
                            { staticClass: "country" },
                            [
                              _c("h3", [
                                _vm._v(
                                  _vm._s(
                                    this.$t(
                                      "dash.reporting.pdf.visibility.demographicData.byCountry"
                                    )
                                  )
                                ),
                              ]),
                              _c("Graph2", {
                                attrs: {
                                  id: "stat-country",
                                  labels:
                                    _vm.getDataSlide[9].dataGraphCountryLabels.map(
                                      (abr) => _vm.country[abr]
                                    ),
                                  data: _vm.getDataSlide[9]
                                    .dataGraphCountryValues,
                                  sufixLabel: "%",
                                  height: "400px",
                                  width: "637px",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "city" },
                            [
                              _c("h3", [
                                _vm._v(
                                  _vm._s(
                                    this.$t(
                                      "dash.reporting.pdf.visibility.demographicData.byCity"
                                    )
                                  )
                                ),
                              ]),
                              _c("Graph2", {
                                attrs: {
                                  id: "stat-city",
                                  labels:
                                    _vm.getDataSlide[9].dataGraphCityLabels,
                                  data: _vm.getDataSlide[9].dataGraphCityValues,
                                  height: "400px",
                                  width: "637px",
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _c("div", { staticClass: "data-not-found" }, [
                          _c("i", {
                            staticClass: "fa-solid fa-magnifying-glass",
                          }),
                          _c("p", [
                            _vm._v(
                              _vm._s(_vm.$t("dash.reporting.pdf.dataNotFound"))
                            ),
                          ]),
                        ]),
                  ],
                  1
                )
              : _vm._e(),
            ["facebook"].includes(_vm.currentPage.network)
              ? _c(
                  "div",
                  { staticClass: "slide slide11" },
                  [
                    _c("ComponentHeader", {
                      attrs: {
                        SectionName: this.$t(
                          "dash.reporting.pdf.publication.sectionName"
                        ),
                        SubSectionName: this.$t(
                          "dash.reporting.pdf.publication.main.subSectionName"
                        ),
                        Description: this.$t(
                          "dash.reporting.pdf.publication.main.description"
                        ),
                        Network: _vm.currentPage.network,
                        PictureUrl: _vm.currentPage.avatar,
                      },
                    }),
                    _vm.graphData && _vm.pageStats && _vm.pageStats.page
                      ? _c("SlideResumeSection", {
                          attrs: {
                            Items: [
                              {
                                icon: "fa-regular fa-square-plus",
                                pourcentage: Math.round(
                                  ((_vm.pageStats.page.nb_posts -
                                    _vm.pageStats.page.previous_period
                                      .nb_posts) /
                                    _vm.pageStats.page.previous_period
                                      .nb_posts) *
                                    100
                                ),
                                title: this.$t(
                                  "dash.reporting.pdf.publication.sectionName"
                                ),
                                value: _vm.pageStats.page.nb_posts,
                              },
                              // {
                              //   icon : 'fa-solid fa-satellite-dish',
                              //   pourcentage : pageStats.page.totalInteractions && pageStats.page.previous_period.totalInteractions ? Math.round((pageStats.page.totalInteractions - pageStats.page.previous_period.totalInteractions) / pageStats.page.previous_period.totalInteractions * 100) : 0,
                              //   title : 'Portée des posts',
                              //   value : pageStats && pageStats.page && pageStats.page.totalInteractions ? pageStats.page.totalInteractions : 0
                              // },
                              {
                                icon: "fa-solid fa-eye",
                                value:
                                  _vm.pageStats &&
                                  _vm.pageStats.page &&
                                  _vm.pageStats.page.totalImpressions
                                    ? _vm.pageStats.page.totalImpressions
                                    : 0,
                                pourcentage:
                                  _vm.pageStats &&
                                  _vm.pageStats.page &&
                                  _vm.pageStats.page.previous_period &&
                                  _vm.pageStats.page.previous_period
                                    .totalImpressions &&
                                  _vm.pageStats.page.totalImpressions
                                    ? Math.round(
                                        ((_vm.pageStats.page.totalImpressions -
                                          _vm.pageStats.page.previous_period
                                            .totalImpressions) /
                                          _vm.pageStats.page.previous_period
                                            .totalImpressions) *
                                          100
                                      )
                                    : 0,
                                title: this.$t("dash.reporting.impression"),
                              },
                              {
                                icon: "fa-solid fa-hand-point-up",
                                value:
                                  _vm.pageStats &&
                                  _vm.pageStats.page &&
                                  _vm.pageStats.page.totalInteractions
                                    ? _vm.pageStats.page.totalInteractions
                                    : 0,
                                pourcentage:
                                  _vm.pageStats &&
                                  _vm.pageStats.page &&
                                  _vm.pageStats.page.previous_period &&
                                  _vm.pageStats.page.previous_period
                                    .totalInteractions &&
                                  _vm.pageStats.page.totalInteractions
                                    ? Math.round(
                                        ((_vm.pageStats.page.totalInteractions -
                                          _vm.pageStats.page.previous_period
                                            .totalInteractions) /
                                          _vm.pageStats.page.previous_period
                                            .totalInteractions) *
                                          100
                                      )
                                    : 0,
                                title: this.$t(
                                  "dash.reporting.pdf.publication.interaction.subSectionName"
                                ),
                              },
                            ],
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            ["facebook"].includes(_vm.currentPage.network)
              ? _c(
                  "div",
                  { staticClass: "slide slide12" },
                  [
                    _c("ComponentHeader", {
                      attrs: {
                        SectionName: this.$t(
                          "dash.reporting.pdf.publication.sectionName"
                        ),
                        SubSectionName: this.$t(
                          "dash.reporting.pdf.publication.interaction.subSectionName"
                        ),
                        Description: this.$t(
                          "dash.reporting.pdf.publication.interaction.description"
                        ),
                        Network: _vm.currentPage.network,
                        PictureUrl: _vm.currentPage.avatar,
                      },
                    }),
                    _c("Graph", {
                      attrs: {
                        id: "graph_type_post",
                        data: _vm.pageStats
                          ? [
                              //{data: this.getDataGraphPublication('snippet'), label: this.$t('dash.reporting.clic'), type: 'bar'},
                              {
                                data: this.getDataGraphPublicationClick(),
                                label: this.$t("dash.reporting.clic"),
                                type: "line",
                              },
                              {
                                data: this.getDataGraphPublication(),
                                label: this.$t("dash.reporting.post"),
                                type: "bar",
                              },
                            ]
                          : [],
                        labels: _vm.graphLabels,
                        height: "762px",
                        width: "1324px",
                      },
                    }),
                    _c(
                      "div",
                      { staticClass: "text-data" },
                      [
                        _vm.graphData && _vm.pageStats && _vm.pageStats.page
                          ? _c("ComponentTab", {
                              attrs: {
                                values: [
                                  {
                                    label: this.$t("dash.reporting.clic"),
                                    // value : pageStats.posts.filter(p => p.type == 'snippet').length
                                    value: _vm.pageStats.page.totalClicks,
                                  },

                                  // {
                                  //   label : 'Images',
                                  //   value : pageStats.page.totalReactions
                                  // },
                                  // {
                                  //   label : 'Video',
                                  //   value : pageStats.page.totalComments
                                  // },
                                  // {
                                  //   label : 'Carrousel (multi-media)',
                                  //   value : pageStats.page.totalShares
                                  // },
                                  // {
                                  //   label : 'Stories',
                                  //   value : pageStats.page.totalClicks
                                  // },
                                  // {
                                  //   label : 'Réels',
                                  //   value : pageStats.page.totalClicks
                                  // }
                                ],
                                totals: [
                                  {
                                    label: this.$t("dash.reporting.pdf.total"),
                                    value: _vm.pageStats.page.nb_posts,
                                  },
                                ],
                              },
                            })
                          : _vm._e(),
                        _vm.graphData && _vm.pageStats && _vm.pageStats.page
                          ? _c("ComponentTextResume", {
                              attrs: {
                                title: "Le nombre total est de",
                                value: _vm.pageStats.page.nb_posts.toString(),
                                label: this.$t(
                                  "dash.reporting.pdf.publications"
                                ),
                                pourcentage: Math.round(
                                  ((_vm.pageStats.page.nb_posts -
                                    _vm.pageStats.page.previous_period
                                      .nb_posts) /
                                    _vm.pageStats.page.previous_period
                                      .nb_posts) *
                                    100,
                                  2
                                ),
                                DateStart: new Date(
                                  _vm.getPreviousPeriod.start
                                    .split("/")
                                    .reverse()
                                    .join("-")
                                ),
                                DateEnd: new Date(
                                  _vm.getPreviousPeriod.end
                                    .split("/")
                                    .reverse()
                                    .join("-")
                                ),
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            ["facebook", "linkedin", "instagram", "tiktok"].includes(
              _vm.currentPage.network
            ) && _vm.pageStats.posts.length
              ? _c(
                  "div",
                  { staticClass: "slide slide13" },
                  [
                    _c("ComponentHeader", {
                      attrs: {
                        SectionName: this.$t(
                          "dash.reporting.pdf.publication.sectionName"
                        ),
                        SubSectionName: this.$t(
                          "dash.reporting.pdf.publication.top3.subSectionName"
                        ),
                        Description: this.$t(
                          "dash.reporting.pdf.publication.top.description"
                        ),
                        Network: _vm.currentPage.network,
                        PictureUrl: _vm.currentPage.avatar,
                      },
                    }),
                    _c("ComponentListCard", {
                      attrs: { posts: _vm.postsSortByImpression.slice(0, 3) },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            ["facebook", "linkedin", "instagram", "tiktok"].includes(
              _vm.currentPage.network
            ) && _vm.pageStats.posts.length
              ? _c(
                  "div",
                  { staticClass: "slide slide14" },
                  [
                    _c("ComponentHeader", {
                      attrs: {
                        SectionName: this.$t(
                          "dash.reporting.pdf.publication.sectionName"
                        ),
                        SubSectionName: this.$t(
                          "dash.reporting.pdf.publication.top15.subSectionName"
                        ),
                        Description: this.$t(
                          "dash.reporting.pdf.publication.top.description"
                        ),
                        Network: _vm.currentPage.network,
                        PictureUrl: _vm.currentPage.avatar,
                      },
                    }),
                    _c("ComponentListItem", {
                      attrs: {
                        posts: _vm.postsSortByImpression,
                        network: _vm.currentPage.network,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            ["facebook", "linkedin", "tiktok"].includes(_vm.currentPage.network)
              ? _c(
                  "div",
                  { staticClass: "slide slide15" },
                  [
                    _c("ComponentHeader", {
                      attrs: {
                        SectionName: this.$t(
                          "dash.reporting.pdf.publication.sectionName"
                        ),
                        SubSectionName: this.$t(
                          "dash.reporting.pdf.publication.bestMoment.subSectionName"
                        ),
                        Description: this.$t(
                          "dash.reporting.pdf.publication.bestMoment.description"
                        ),
                        Network: _vm.currentPage.network,
                        PictureUrl: _vm.currentPage.avatar,
                      },
                    }),
                    _vm.pageStats &&
                    _vm.pageStats.page &&
                    _vm.pageStats.page.optimalTimes &&
                    _vm.pageStats.page.optimalTimes.optimalTimeSlots
                      ? _c("GraphCalendar", {
                          attrs: {
                            data: Object.values(
                              _vm.pageStats.page.optimalTimes.optimalTimeSlots
                            ).map((dataHours) =>
                              dataHours.map((hour) =>
                                hour ? hour.totalReachEngagement : 0
                              )
                            ),
                            optimalTimes: _vm.pageStats.page.optimalTimes,
                          },
                        })
                      : _vm._e(),
                    _c("div", { staticClass: "lengendCalendar" }, [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            this.$t(
                              "dash.reporting.pdf.publication.bestMoment.lessEngaging"
                            )
                          )
                        ),
                      ]),
                      _c("div"),
                      _c("div"),
                      _c("div"),
                      _c("div"),
                      _c("div"),
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            this.$t(
                              "dash.reporting.pdf.publication.bestMoment.moreEngaging"
                            )
                          )
                        ),
                      ]),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm.currentPage.network === "tiktok" &&
            _vm.pageStats.page.concurrences &&
            _vm.pageStats.page.concurrences.length > 0
              ? _c(
                  "div",
                  { staticClass: "slide slide16" },
                  [
                    _c("ComponentHeader", {
                      attrs: {
                        SectionName: this.$t(
                          "dash.reporting.pdf.competitors.sectionName"
                        ),
                        SubSectionName: this.$t(
                          "dash.reporting.pdf.competitors.subSectionName"
                        ),
                        Description: this.$t(
                          "dash.reporting.pdf.competitors.description"
                        ),
                        Network: _vm.currentPage.network,
                        PictureUrl: _vm.currentPage.avatar,
                      },
                    }),
                    _c("div", { staticClass: "competitors-table" }, [
                      _c("table", { staticClass: "pdf-table" }, [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "dash.reporting.section.concurrences.list.head.name"
                                  )
                                )
                              ),
                            ]),
                            _c("th", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "dash.reporting.section.concurrences.list.head.follower_count"
                                  )
                                )
                              ),
                            ]),
                            _c("th", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "dash.reporting.section.concurrences.list.head.follower_variation"
                                  )
                                )
                              ),
                            ]),
                            _c("th", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "dash.reporting.section.concurrences.list.head.posts_count"
                                  )
                                )
                              ),
                            ]),
                            _c("th", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "dash.reporting.section.concurrences.list.head.likes_count"
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ]),
                        _c(
                          "tbody",
                          [
                            _c("tr", { staticClass: "main-page" }, [
                              _c("td", [_vm._v(_vm._s(_vm.currentPage.name))]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.pageStats.page.page_follows &&
                                      _vm.pageStats.page.page_follows.length
                                      ? _vm.numberSpacing(
                                          _vm.pageStats.page.page_follows[
                                            _vm.pageStats.page.page_follows
                                              .length - 1
                                          ].total
                                        )
                                      : _vm.numberSpacing(
                                          _vm.pageStats.page.page_fans
                                        )
                                  )
                                ),
                              ]),
                              _c(
                                "td",
                                {
                                  class: {
                                    positive:
                                      _vm.pageStats.page.page_follows &&
                                      _vm.pageStats.page.page_follows.length >
                                        1 &&
                                      _vm.pageStats.page.page_follows[
                                        _vm.pageStats.page.page_follows.length -
                                          1
                                      ].total -
                                        _vm.pageStats.page.page_follows[0]
                                          .total >
                                        0,
                                    negative:
                                      _vm.pageStats.page.page_follows &&
                                      _vm.pageStats.page.page_follows.length >
                                        1 &&
                                      _vm.pageStats.page.page_follows[
                                        _vm.pageStats.page.page_follows.length -
                                          1
                                      ].total -
                                        _vm.pageStats.page.page_follows[0]
                                          .total <
                                        0,
                                  },
                                },
                                [
                                  _vm.pageStats.page.page_follows &&
                                  _vm.pageStats.page.page_follows.length > 1
                                    ? [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.pageStats.page.page_follows[
                                                _vm.pageStats.page.page_follows
                                                  .length - 1
                                              ].total -
                                                _vm.pageStats.page
                                                  .page_follows[0].total >
                                                0
                                                ? "+"
                                                : ""
                                            ) +
                                            _vm._s(
                                              _vm.numberSpacing(
                                                _vm.pageStats.page.page_follows[
                                                  _vm.pageStats.page
                                                    .page_follows.length - 1
                                                ].total -
                                                  _vm.pageStats.page
                                                    .page_follows[0].total
                                              )
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    : [_vm._v("N/A")],
                                ],
                                2
                              ),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.numberSpacing(
                                      _vm.pageStats.page.page_post_count
                                    )
                                  )
                                ),
                              ]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.numberSpacing(
                                      _vm.pageStats.page.page_likes
                                    )
                                  )
                                ),
                              ]),
                            ]),
                            _vm._l(
                              _vm.pageStats.page.concurrences,
                              function (concurrent, index) {
                                return _c(
                                  "tr",
                                  { key: `pdf-concurrent-${index}` },
                                  [
                                    _c("td", [
                                      _vm._v(_vm._s(concurrent.concurrentName)),
                                    ]),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.numberSpacing(
                                            concurrent.pageFollowers
                                          )
                                        )
                                      ),
                                    ]),
                                    _c(
                                      "td",
                                      {
                                        class: {
                                          positive:
                                            concurrent.pageFollowersVariation >
                                            0,
                                          negative:
                                            concurrent.pageFollowersVariation <
                                            0,
                                        },
                                      },
                                      [
                                        concurrent.pageFollowersVariation !==
                                          null &&
                                        concurrent.pageFollowersVariation !==
                                          undefined
                                          ? [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    concurrent.pageFollowersVariation >
                                                      0
                                                      ? "+"
                                                      : ""
                                                  ) +
                                                  _vm._s(
                                                    _vm.numberSpacing(
                                                      concurrent.pageFollowersVariation
                                                    )
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          : [_vm._v("N/A")],
                                      ],
                                      2
                                    ),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.numberSpacing(
                                            concurrent.pagePostCount
                                          )
                                        )
                                      ),
                                    ]),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.numberSpacing(
                                            concurrent.pageLikes
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                      ]),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }